import React from "react"
import { injectIntl } from "react-intl"
import { Header } from "../../common/headers"
import IntlProps from "../../state/helpers/IntlProps"
import { STOCK_CONTROL_PAGE_MESSAGES } from "../../utils/inventory"
import { MainTabsComponent } from "../components"
import { StockDocumentListingSection } from "../sections"

export const StockControl = injectIntl((props: IntlProps) => {
    return (
        <>
            <MainTabsComponent/>
            <Header title={props.intl.formatMessage(STOCK_CONTROL_PAGE_MESSAGES["header"])}/>
            <hr/>

            <StockDocumentListingSection/>
        </>
    )
})


// WEBPACK FOOTER //
// ./src/inventory/pages/StockControl.tsx